<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-02-21 11:49:33
 * @FilePath: /smartEarthDemo/src/demo/earth/vector_point.vue
 * @Description: 
-->
<template>
<div style="height:100%">
    <div id="cesiumContainer"></div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widget from "cesium/Widgets/widgets.css";
export default {
    data () {
        return {

        }
    },
    mounted(){
          var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
      this.init();
    },
    methods:{
       init () {
           var viewerOption = {
                    geocoder: true, // 地理位置查询定位控件
                    homeButton: true, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: true, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: true, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                };
                var czml = [{
                        "id" : "document",
                        "name" : "CZML Point",
                        "version" : "1.0"
                        }, {
                        "id" : "point 3",
                        "name": "point",
                        "position" : {
                            "cartographicDegrees" : [-111, 40.0, 0]
                        },
                        "point": {
                            "color": {
                                "rgba":[255, 255, 0, 255]
                            },
                            "outlineColor": {
                                "rgba": [255, 0, 0, 255]
                            },
                            "outlineWidth" : 4,
                            "pixelSize": 40
                        }
                    }];
            Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNWZhODgzMC1iNmE5LTQzNWMtOTdiYi00NzAyMzhmZDdmNjgiLCJpZCI6MTg3NTAyLCJpYXQiOjE3MDQyNDkwODl9.81WSf-TbP_6rNXQpVmuQaca_IrKpBje4NKk-BQxt4hg';
            let viewer=new Cesium.Viewer('cesiumContainer',viewerOption)
            viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
            var dataSourcePromise = Cesium.CzmlDataSource.load(czml);
            viewer.dataSources.add(dataSourcePromise);
            viewer.zoomTo(dataSourcePromise);
       }
    }
}
</script>
<style scoped>
    #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>